import { render, staticRenderFns } from "./ShouninList.vue?vue&type=template&id=5e92d2d7&scoped=true&"
import script from "./ShouninList.vue?vue&type=script&lang=ts&"
export * from "./ShouninList.vue?vue&type=script&lang=ts&"
import style0 from "./ShouninList.vue?vue&type=style&index=0&id=5e92d2d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e92d2d7",
  null
  
)

export default component.exports